import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { Form, Formik } from 'formik';

import FormField from 'components/common/formikForm/formField';
import SubmitButton from 'components/common/formikForm/SubmitButton';

import { Role } from 'data/constants/roles';
import useTranslate from 'hooks/useTranslate';
import { OrganizationAgentFormInterface } from 'types';
import {
    organizationAgentFormInitialValues,
    organizationAgentFormValidationSchema,
} from 'utils/validations/organization';

const ROLE_OPTIONS = [
    { label: 'Backoffice Consultant', value: Role.BACKOFFICE_CONSULTANT },
    { label: 'Backoffice Admin', value: Role.BACKOFFICE_ADMIN },
    { label: 'Sales', value: Role.SALES },
];

interface Props {
    disabled?: boolean;
    title: string;
    onClose: () => void;
    onSubmit: (value: OrganizationAgentFormInterface) => void | Promise<void>;
}

const OrganizationAgentForm = ({ disabled, title, onClose, onSubmit }: Props) => {
    const { translate } = useTranslate();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Dialog open fullWidth maxWidth="sm" fullScreen={fullScreen} scroll="paper">
            <Formik
                enableReinitialize
                initialValues={organizationAgentFormInitialValues}
                validationSchema={organizationAgentFormValidationSchema}
                onSubmit={onSubmit}
            >
                <Box
                    component={Form}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                        minHeight: 0,
                    }}
                >
                    <DialogTitle>{translate(title)}</DialogTitle>

                    <DialogContent dividers sx={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
                        <Stack spacing={1}>
                            <FormField
                                required
                                type="string"
                                name="firstname"
                                label="firstName"
                                disabled={disabled}
                            />
                            <FormField
                                required
                                type="string"
                                name="lastname"
                                label="lastName"
                                disabled={disabled}
                            />
                            <FormField
                                required
                                type="string"
                                name="email"
                                label="email"
                                disabled={disabled}
                            />
                            <FormField
                                required
                                type="select"
                                name="role"
                                label="role"
                                disabled={disabled}
                                options={ROLE_OPTIONS}
                            />
                        </Stack>
                    </DialogContent>

                    <DialogActions sx={{ flexShrink: 0, px: 3, py: 2, gap: 1 }}>
                        <Button
                            onClick={onClose}
                            color="inherit"
                            disabled={disabled}
                            sx={{ borderRadius: '8px' }}
                        >
                            {translate('cancel')}
                        </Button>
                        <SubmitButton loading={disabled}>createAgent</SubmitButton>
                    </DialogActions>
                </Box>
            </Formik>
        </Dialog>
    );
};

export default OrganizationAgentForm;
